import { Empty as AntEmpty } from "antd";

import styled, { css } from "styled-components";

export const Empty = styled(AntEmpty)<{ loading?: boolean }>`
  ${({ loading }) =>
    loading &&
    css`
      .ant-empty-image {
        display: flex;
        flex: 1;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    `}
`;
